

<ng-container>
<div class="page-wrap mobile-wrap" (click)="dismissSidenav(true)">
  <app-mobile-header *ngIf="router.url !== '/login' && router.url !== '/register'"></app-mobile-header>
  <main>
    <div id="scroll-view-content" class="content" [ngClass]="{'content--fullHeight' : router.url == '/login' || router.url == '/register', 'without-navbar' : router.url == '/'}">
      <router-outlet></router-outlet>
      <div class="appMobile__appSeoTextsWrapper">
        <app-seo-texts-wrapper></app-seo-texts-wrapper>
      </div>
    </div>
  </main>
  <app-mobile-footer *ngIf="router.url !== '/login' && router.url !== '/register'"></app-mobile-footer>
</div>
</ng-container>

